import { Step } from '../../course/step';
import { StepSubmissionExam } from './step-submission-exam';

export class StepExam extends Step {
  public submissions?: StepSubmissionExam[];
}
